import { render } from "./Auth.vue?vue&type=template&id=5870ae4c"
const script = {}

import "./Auth.vue?vue&type=style&index=0&id=5870ae4c&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__